import React from "react";
import { Grid, Switch, FormControlLabel } from "@mui/material";

import InsuranceInformationDetail from "./InsuranceInformationDetail";
import GuarantorInformationDetail from "./guarantor/GuarantorInformationDetail";
import BenchmarkInsurances from "./benchmarkInsurances/BenchmarkInsurances";
import useInsuranceInformation from "./useInsuranceInformation";
import LoadingModal from "components/common/loading/LoadingModal";

const InsuranceInformation = () => {
  const {
    information,
    handleUpdateSelfPayStatus,
    handleUpdatePreAuthStatus,
    isUpdatingSelfPay,
    isUpdatingPreAuth,
  } = useInsuranceInformation();

  return (
    <>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                name="self_pay"
                checked={information?.self_pay || false}
                onChange={(_event, checked) => {
                  handleUpdateSelfPayStatus(checked);
                }}
              />
            }
            label="Self Pay"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                name="pre_auth"
                checked={information?.pre_auth || false}
                onChange={(_event, checked) => {
                  handleUpdatePreAuthStatus(checked);
                }}
              />
            }
            label="Pre-Auth"
          />
        </Grid>
      </Grid>

      {information?.idtf && (
        <div className="patient-modal__section">
          <div className="patient-form__row">
            <BenchmarkInsurances />
          </div>
        </div>
      )}
      <div className="patient-modal__section mt-2">
        <div className="patient-form__row">
          <Grid container>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <div className="patient-form__info--header">
                Insurance Information
              </div>
            </Grid>
            <Grid item xs={12}>
              <InsuranceInformationDetail
                title="PRIMARY INSURANCE"
                type={"insurance"}
                allowEdit={information?.self_pay ? false : true}
              />
              <InsuranceInformationDetail
                title="SECONDARY INSURANCE"
                type={"secondaryInsurance"}
                allowEdit={information?.self_pay ? false : true}
              />
              <InsuranceInformationDetail
                title="TERTIARY INSURANCE"
                type={"tertiaryInsurance"}
                allowEdit={information?.self_pay ? false : true}
              />
              <GuarantorInformationDetail />
            </Grid>
          </Grid>
        </div>
      </div>
      {isUpdatingSelfPay && (
        <LoadingModal loadingText="Updating Self Pay Status..." />
      )}
      {isUpdatingPreAuth && (
        <LoadingModal loadingText="Updating Pre-Auth Status..." />
      )}
    </>
  );
};

export default InsuranceInformation;
